import { APP_PROPERTIES } from '../constants';

export const propertiesInclude = (properties, propertyName) =>
  properties?.some(property => property?.name === propertyName);

export const categoriesInclude = (categories, categoryName) =>
  categories?.map(c => c?.slug).includes(categoryName);

export const getBadgeContent = (properties, categories) => {
  if (propertiesInclude(properties, APP_PROPERTIES.BETA)) {
    return 'Beta';
  }
  if (propertiesInclude(properties, APP_PROPERTIES.COMING_SOON)) {
    return 'Coming soon';
  }
  if (propertiesInclude(properties, APP_PROPERTIES.PREFERRED_PARTNER)) {
    return 'Preferred partner';
  }
  if (categoriesInclude(categories, 'popular')) {
    return 'Popular';
  }
  return null;
};

export default getBadgeContent;
